import { render, staticRenderFns } from "./Slant.vue?vue&type=template&id=35467a5e&"
import script from "./Slant.vue?vue&type=script&lang=js&"
export * from "./Slant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  "2b43bde4"
  
)

export default component.exports